import React from 'react';

import AdminLogic from './AdminLogic';

export default function Admin(props) {
  AdminLogic(props);

  return <></>;
}
